// extracted by mini-css-extract-plugin
export default {"ScreenMDMin":"(min-width: 992px)","resetButton":"G30cc50","arrow":"Ga02fd2 G30cc50","left":"Ge40cd0","right":"G43de6d"};